import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { ProductionLogForm } from "./components/ProductionLogForm";

export default function ProductionLogCreate() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as {
    orderId?: string;
    routingStepId?: string;
    processType?: string;
  };

  const initialOrderId = search.orderId || "";
  const initialStepId = search.routingStepId || "";
  const processType = search.processType || "";

  return (
    <div className="max-w-3xl mx-auto p-4 md:p-6">
      <ProductionLogForm
        isModal={false}
        prefill={
          initialOrderId
            ? {
                productionOrderId: initialOrderId,
                routingStepId: initialStepId,
              }
            : undefined
        }
        processType={processType}
        onSuccess={() => {
          navigate({ to: "/factory/production-logs" as any, replace: true });
        }}
        onCancel={() => {
          navigate({ to: "/factory/production-logs" as any });
        }}
      />
    </div>
  );
}
